<template lang="pug">
.max-container.v2
  .abtn-group
    a.abtn(href="javascript:void(0)" @click="toDeposit") {{$t('ui.deposit')}}
    a.abtn.active(href="javascript:void(0)") {{$t('ui.withdrawal')}}
  balanceInfo
  .t-content
    .withdraw-form.mb-4(v-if="promoBind")
      .d-flex.justify-content-center.mb-2
        .text-uppercase.font-weight-bold.text-center.chosen-promo
          | {{ $t("ui.promotion_selected") }}: {{ promoDetails }}
          //- span.icon-info.ml-2(data-dismiss='modal' data-toggle='modal' data-target='#modal-promo01')
          //-   img(src='img/icon-info.svg')
      .mb-2.text-center.text-progress {{ $t("ui.progress") }}: {{ $numeral(promoAccumulate).format("0,0.00") }} / {{ $numeral(promoTarget).format("0,0.00") }}
      .mx-auto.mb-2.progress-wrap
        .progress
          .progress-bar.progress-bar-animated.bg-warning.text-dark.font-weight-bold.text-right.pr-2(
            role='progressbar'
            :style="'width:' + promoProgress + '%'"
            :aria-valuenow="promoProgress"
            aria-valuemin='0'
            aria-valuemax='100'
          ) 
          .percent {{ $numeral(promoProgress).format("0.0[0]") }}%
      .text-center.mb-3.text-danger
        i {{ $t('ui.withdraw_target_tips') }}
      //- .text-center
        a(href='#' data-dismiss='modal' data-toggle='modal' data-target='#modal-withdrawal')
          .btn.btn-main.btn-close-custom {{ $t("ui.withdrawal") }}
    .mt-2(v-else)
      .mb-3.text-warning {{ $t('ui.withdrawal_reminder') }}
      .mb-3
        label.col-form-label {{ $t('ui.amount') }} ({{ $t('ui.min_amount') }} : {{ $store.getters.currencyCode }} {{ minWithdrawal }})
        input.form-control(type="text" :placeholder="'eg.' + minWithdrawal" v-model.trim="$v.withdrawAmount.$model" @keypress="$helpers.onlyNumber" @paste.prevent)
        ValidateResult(:value="$v.withdrawAmount" :name="$t('ui.amount')")
      .mb-3
        label.col-form-label {{ $t('ui.bank_name') }}
        input.form-control.disable-display(type="text" :placeholder="$store.getters.bankName" disabled)
      .mb-3
        label.col-form-label {{ $t('ui.bank_accname') }}
        input.form-control.disable-display(type="text" :placeholder="$store.getters.bankAccHolder" disabled)
      .mb-3
        label.col-form-label {{ $t('ui.bank_accno') }}
        input.form-control.disable-display(type="text" :placeholder="$store.getters.bankAccNo" disabled)
      .withdrawal-detail
        ul.d-flex
          li
            img(src='img/wtihdrawal_icon01.svg')
            span {{ $t("ui.withdrawal_details1") }}
          li
            img(src='img/wtihdrawal_icon02.svg')
            span {{ $t("ui.withdrawal_details2") }}
          li
            img(src='img/wtihdrawal_icon03.svg')
            span {{ $t("ui.withdrawal_details3") }}
      .my-4.text-center.d-flex.gap-4.justify-content-center
        button.btn-submit(type='button' @click.stop="addWithdrawTicket") {{ $t('ui.submit') }}
</template>

<script>
import config from "@/config"
import errorTags from "@/errorTags"
import balanceInfo from '@/components2/_balanceInfo.vue'
import { required, minValue } from "vuelidate/lib/validators"
import ValidateResult from "@/library/ValidateResult"

export default {
  components: {
    ValidateResult,
    balanceInfo
  },
  data() {
    return {
      promoTarget: "",
      promoDetails: "",
      promoProgress: "",
      promoAccumulate: "",
      promoBind: false,
      withdrawAmount: "",
      minWithdrawal: 0,
      feedback: {
        success: true,
        status: ""
      },
      refreshPromoStatus: null,
      showTutorial: false,
      startRender:false
    };
  },
  validations() {
    return {
      withdrawAmount: {
        required,
        minValue: minValue(this.minWithdrawal)
      }
    };
  },
  computed: {
    accountID() {
      return this.$store.getters.accountID
    },
    sessionToken() {
      return this.$store.getters.sessionToken
    },
  },
  watch:{
    sessionToken(newState, oldState){
      var vm = this
      if(newState === '' || newState === undefined){
        vm.$router.push("/").catch(err => {});
      }
    }
  },
  created(){
    if(this.$store.getters.transaction.length === 0){
      this.$router.push({
        name:"profile",
        params:{
          "addBank": true
        }
      }).catch(error =>{})
    }
  },
  beforeDestroy(){
    // vm.showTutorial = false;
    this.clearIntervalLoop()
  },
  mounted() {
    var vm = this
    vm.getPromotionStatus()
    vm.getBankingMode()
    vm.refreshPromoStatus = setInterval(() => {
      vm.getPromotionStatus()
    }, 10000)
  },
  methods: {
    toDeposit(){
      this.$router.push("deposit").catch(error =>{})
    },
    openTutorial(){
      this.showTutorial =true;
    },
    closeTutorial(){
      this.showTutorial = false;
    },
    clearIntervalLoop(){
      clearInterval(this.refreshPromoStatus);
    },
    reset() {
      this.promoTarget = ""
      this.promoDetails = ""
      this.promoProgress = ""
      this.promoAccumulate = ""
      this.withdrawAmount = 0
      this.minWithdrawal = 0
      this.feedback.success = true
      this.feedback.status = ""
      this.$v.$reset()
    },
    getPromotionStatus() {
      if (this.sessionToken) {
        let account_id = this.accountID
        let auth_token = this.sessionToken
        this.$store
          .dispatch("user/getPromotionStatus", { account_id, auth_token })
          .then(response => {
            if (response.success == true) {
              let promoCriteria = response.data[0].a
              let accumulateWin = response.data[0].c
              let accumulateTurnover = response.data[0].d
              
              this.promoTarget = response.data[0].b
              this.promoDetails = response.data[0].e

              if (promoCriteria == "TURNOVER") {
                var initialProgress = Number(((accumulateTurnover / this.promoTarget) * 100))
                // this.promoProgress = Number(((accumulateTurnover / this.promoTarget) * 100).toFixed(2))
                this.promoProgress = Number(((accumulateTurnover / this.promoTarget) * 100).toString().substring(0,5));
                if(initialProgress < 0){
                  this.promoProgress = 0;
                }
                this.promoAccumulate = response.data[0].d
                if(this.promoAccumulate < 0){
                  this.promoAccumulate = 0;
                }
                this.promoBind = (initialProgress < 100) ? true : false
              } else if (promoCriteria == "WIN") {
                var initialProgress = Number(((accumulateWin / this.promoTarget) * 100));
                // this.promoProgress = Number(((accumulateWin / this.promoTarget) * 100).toFixed(2))
                this.promoProgress = Number(((accumulateWin / this.promoTarget) * 100).toString().substring(0,5));
                if(initialProgress < 0){
                  this.promoProgress = 0;
                }
                this.promoAccumulate = response.data[0].c
                if(this.promoAccumulate < 0){
                  this.promoAccumulate = 0;
                }
                this.promoBind = (initialProgress < 100) ? true : false
              } else {
                this.promoBind = false
              }
            } else {
              if((typeof response.status) != 'object'){
                this.$helpers.showDialog(this.$t("ui.attention"), this.$t("message.list." + response.status), "info", this);
              }
            }
          })
          .catch(response => {
            if((typeof response.status) != 'object'){
              this.$helpers.showDialog(this.$t("ui.attention"), this.$t("message.list." + response.status), "info", this);
            }
            $('body').removeClass('modal-open');
            $('.modal-backdrop').remove();
          });
      }
    },
    getBankingMode() {
      if (this.sessionToken) {
        let account_id = this.accountID
        let auth_token = this.sessionToken
        this.$store
          .dispatch("user/getBankingMode", { account_id, auth_token })
          .then(response => {
            if (response.success == true) {
              this.minWithdrawal = (response.data.min_setting.filter(item => item.setting_key === "min_withdrawal"))[0].setting_value
            } else {
              if((typeof response.status) != 'object'){
                this.$helpers.showDialog(this.$t("ui.attention"), this.$t("message.list." + response.status), "info", this);
              }
            }
          })
          .catch(response => {
            if((typeof response.status) != 'object'){
              this.$helpers.showDialog(this.$t("ui.attention"), this.$t("message.list." + response.status), "info", this);
            }
          })
      }
    },
    addWithdrawTicket(){
      this.$v.$touch()
      if (!this.$v.$invalid) {
        if(this.sessionToken) {
          let account_id = this.accountID
          let withdrawal_amount = this.withdrawAmount
          let auth_token = this.sessionToken
          this.loading = true
          this.$store
            .dispatch("user/addWithdrawTicket", { account_id, withdrawal_amount, auth_token })
            .then(response => {
              this.loading = false
              this.feedback.success = response.success
              this.feedback.status = response.status
              if (this.feedback.success == true) {
                this.reset()
                // $('#modal-review').modal({backdrop: 'static', keyboard: false}) 
                $('#modal-review').modal("show")
                this.$router.push({
                  name:"statement",
                  params:{
                    "checkTrans": true
                  }
                }).catch(error =>{})
              } else {
                this.feedback.status = this.$t("error." + response.status)
                if((typeof response.status) != 'object'){
                  this.$helpers.showDialog(this.$t("ui.attention"), this.$t("message.list." + response.status), "info", this);
                }
              }
            })
            .catch(response => {
              this.loading = false
              this.feedback.success = false
              if((typeof response.status) != 'object'){
                this.$helpers.showDialog(this.$t("ui.attention"), this.$t("message.list." + response.status), "info", this);
              }
              this.feedback.status = this.$t("error." + response.status)
            });
        }
      }
    },
  }
};
</script>
